module.exports = __webpack_public_path__ + "static/media/bene-image.217f1cbc.svg";